<div class="loader-wrapper">
    <div class="preloader" id="loader" >
        <div class="loader">
            <div class="loader__figure"></div>
            <p class="loader__label">My Masjid</p>
        </div>
    </div>
</div>